import { useState } from "react";
import "./AIWriterPopover.css";

const TONES = [
  { value: "professional", label: "Professional" },
  { value: "friendly",     label: "Friendly"     },
  { value: "urgent",       label: "Urgent"        },
];

const AIWriterPopover = ({ onGenerate, isGenerating }) => {
  const [tone, setTone] = useState("professional");

  return (
    <div className="aiwp-popover">
      <div className="aiwp-arrow" />
      <p className="aiwp-heading">Choose a tone</p>
      <div className="aiwp-tone-group">
        {TONES.map((t) => (
          <button
            key={t.value}
            type="button"
            className={`aiwp-tone-btn${tone === t.value ? " aiwp-tone-active" : ""}`}
            onClick={() => setTone(t.value)}
          >
            {t.label}
          </button>
        ))}
      </div>
      <button
        type="button"
        className="aiwp-generate-btn"
        disabled={isGenerating}
        onClick={() => onGenerate(tone)}
      >
        {isGenerating ? (
          <>
            <span className="aiwp-spinner" /> Generating…
          </>
        ) : (
          <>
            <span className="aiwp-star">✦</span> Generate
          </>
        )}
      </button>
    </div>
  );
};

export default AIWriterPopover;
